import { FC } from 'react';

import Typography from '@/components/typography';

import { MobileNavExpandButtons } from './mobileNavExpandButtons';

export const MobileNavHeader: FC = () => {
  return (
    <div className="sticky top-0 z-[100] flex h-[56px] w-full bg-white py-4">
      <Typography variant="button1">Map</Typography>

      <div className="flex-1 flex-grow" />
      <MobileNavExpandButtons />
    </div>
  );
};
